import React from 'react'
import Head from '../components/Head'
import Header from '../components/Header'
import Intro from '../components/IntroAbout'
import BiColumn__about from '../components/biColumn__about'
import QuadColumn from '../components/quadColumn'
import QuadColumn__timeline from '../components/quadColumn__timeline'
import TriColumn__press from '../components/triColumn__press'
import Investors from '../components/investors'
import Footer from '../components/footer'
import Button from '../components/Button'
import scrollToTop from '../scrollToTop'
import { Link } from 'react-router-dom'

export default class extends React.Component {
  render() {
    return (
      <React.Fragment>
        <Head
          title="PlayVS | About"
          description="PlayVS is the official high school esports league, sanctioned by the NFHS. Play with your friends, compete for your school, and win the state championship."
          keywords="high school esports"
        />

        <Header />

        <Intro />

        <BiColumn__about />

        <QuadColumn />

        <QuadColumn__timeline />

        <TriColumn__press />

        <Investors />

        <section className="section section--blueGradient">
          <div className="container">
            <div className="section__head">
              <h2>Work at PlayVS</h2>
              <p>Join our team and help pioneer the future of high school esports.</p>
            </div>
            <div className="section__CTA">
              <Link to="/careers" onClick={scrollToTop}>
                <Button type="button" className="btn btn__primary" text="Open Positions" />
              </Link>
            </div>
          </div>
        </section>

        <Footer />
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/ui/pages/about.js